module.exports = __webpack_public_path__ + "static/media/aahar2.0008fa16.png";